import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { Grid, Cell } from 'react-flexr';
import CategoryCards from '../common/category-cards';
import UniqueSellingPoints from '../common/unique-selling-points';

class Frontpage extends Component {
  render() {
    return (
      <DocumentMeta extend>
        <UniqueSellingPoints />

        <Grid hAlign="center">
          <Cell style={{ textAlign: 'center' }}>
            <h4>Spar Penge - Find de bedste tilbud</h4>
          </Cell>
        </Grid>

        <CategoryCards />
      </DocumentMeta>
    );
  }
}

export default Frontpage;
